import { render, staticRenderFns } from "./quotationHistory.vue?vue&type=template&id=0f0b5024&scoped=true"
import script from "./quotationHistory.vue?vue&type=script&lang=js"
export * from "./quotationHistory.vue?vue&type=script&lang=js"
import style0 from "./quotationHistory.vue?vue&type=style&index=0&id=0f0b5024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0b5024",
  null
  
)

export default component.exports